// Frontend counterpart of api/lib/au-timezones.js. Keep the values identical.
// This module is deliberately small so event discovery, calendar exports and
// organiser forms all use one browser-side timezone map.

// Fixed operations zone for surfaces that have no venue state to anchor to
// (free-form promotion windows, and their reviewer-facing display in the
// admin queue) so the submitter's browser zone and the reviewer's browser
// zone always agree on the same instant.
export const OPERATIONS_TIME_ZONE = 'Australia/Sydney';

export const STATE_TIME_ZONES: Readonly<Record<string, string>> = {
  ACT: 'Australia/Sydney',
  NSW: 'Australia/Sydney',
  NT: 'Australia/Darwin',
  QLD: 'Australia/Brisbane',
  SA: 'Australia/Adelaide',
  TAS: 'Australia/Hobart',
  VIC: 'Australia/Melbourne',
  WA: 'Australia/Perth',
};

export const STATE_COMPATIBLE_TIME_ZONES: Readonly<Record<string, readonly string[]>> = {
  ACT: ['Australia/Sydney', 'Australia/Canberra'],
  NSW: ['Australia/Sydney', 'Australia/Broken_Hill', 'Australia/Lord_Howe'],
  NT: ['Australia/Darwin'],
  QLD: ['Australia/Brisbane', 'Australia/Lindeman'],
  SA: ['Australia/Adelaide'],
  TAS: ['Australia/Hobart'],
  VIC: ['Australia/Melbourne'],
  WA: ['Australia/Perth', 'Australia/Eucla'],
};

export const stateTimeZone = (code: string | null | undefined): string | undefined => (
  STATE_TIME_ZONES[(code || '').trim().toUpperCase()]
);

export const stateCompatibleTimeZone = (
  code: string | null | undefined,
  supplied: string | null | undefined,
): string | undefined => {
  const stateCode = (code || '').trim().toUpperCase();
  const candidate = (supplied || '').trim();
  return STATE_COMPATIBLE_TIME_ZONES[stateCode]?.includes(candidate)
    ? candidate
    : stateTimeZone(stateCode);
};
